export default __webpack_public_path__ + "static/media/notify.6ff06e9d.mp3";